<template>
	<Modal title="Notes" @close="close()">
		<template v-slot:content>
			<div class="content">
				<textarea v-model="$state._patient.patientUIData.notes" @input="validateInput"></textarea>
			</div>
		</template>
		<template v-slot:footer>
			<div class="buttons">
				<button @click="cancel()" class="button-blank-color roundButton">Cancel</button>
				<button @click="save()" :disabled="buttonDisabled()" class="button-primary-color roundButton">Save</button>
			</div>
		</template>
	</Modal>
</template>

<script>
	import Modal from '../Modal';
	import UtilsStore from '@/store/utilsStore';
	import errorMessages from '@/assets/error-messages.json';

	export default {
		name: 'NotesModal',
		components: { Modal },
		data() {
			return {
				defaultData: this.$state._patient.patientUIData.notes
			};
		},
		methods: {
			close() {
				this.$emit('close');
			},
			cancel() {
				this.$state._patient.patientUIData.notes = this.defaultData;
				this.close();
			},
			async save() {
				await this.$state._patient.updateMedicalProfile({ update: true });
				this.close();
			},
			validateInput(e) {
				const res = UtilsStore.unifiedValidatorsForTextarea(e.data);
				if (res) {
					this.$state._patient.patientUIData.notes = UtilsStore.removeInvalidCharactersForTextarea(this.$state._patient.patientUIData.notes);
					this.$state.utils.pushMessage(errorMessages.snackbars.invalidCharacters);
				}
			},
			buttonDisabled() {
				const notes = this.$state._patient.patientUIData.notes;

				if (UtilsStore.unifiedValidatorsForTextarea(notes)) {
					this.$state.utils.pushMessage(errorMessages.snackbars.invalidCharacters);
					return true;
				}
				return false;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.buttons {
		display: flex;
		justify-content: space-evenly;
		width: 45vw;

		button {
			font-size: var(--step--1);
			min-width: 150px;
			min-height: 45px;
			width: 12vw;
			height: 2.5vw;
			border-radius: 72px;
		}

		padding-bottom: calc(var(--step-2));
	}

	.content {
		margin: auto;
		@media (orientation: landscape) {
			//width: 52vw;
			height: 46vh;
			max-height: 23vw;
		}

		@media (orientation: portrait) {
			width: 72vw;
			height: 22vh;
		}

		padding: var(--step-4) calc(var(--step-5) * 2);

		textarea {
			outline: none !important;
			padding: 15px 15px 0 15px;
			width: 100%;
			height: 100%;
			border-radius: 16px;
			border: 1px solid black;
			font-size: var(--step-0);
			padding: 1rem;
			box-sizing: border-box;
			resize: none;
		}
	}

	.shoeContainer {
		width: 100%;
		display: flex;
		justify-content: center;
		flex-direction: row;
	}
</style>
